<template>
    <aside id="sidebar">
        <div class="sidebar-in">
            <div class="form-group">
                <el-select
                    v-model="thisSelectType"
                    size="small">
                    <el-option
                        v-for="item in params.makeTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>

            <div class="form-group mb0">
                <label class="form-label">サイズ</label>
                <div class="input-range">
                    <el-slider v-model="params.size" input-size="mini" :max="50" show-input></el-slider>
                </div>
            </div>

            <template v-if="thisSelectType === 'path'">
                <div class="form-group mb0">
                    <label class="form-label">マージン横</label>
                    <div class="input-range">
                        <el-slider v-model="params.marginX" input-size="mini" :max="50" show-input></el-slider>
                    </div>
                </div>

                <div class="form-group mb0">
                    <label class="form-label">マージン縦</label>
                    <div class="input-range">
                        <el-slider v-model="params.marginY" input-size="mini" :max="50" show-input></el-slider>
                    </div>
                </div>
            </template>
            <div class="form-group mb0" v-else>
                <label class="form-label">マージン</label>
                <div class="input-range">
                    <el-slider v-model="params.margin" input-size="mini" show-input></el-slider>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">回転</label>
                <div class="input-range">
                    <el-slider v-model="params.rotate" input-size="mini" :max="180" show-input></el-slider>
                </div>
            </div>

            <div class="l-row">
                <div class="l-col">
                    <div class="form-group is-inline">
                        <el-color-picker v-model="params.fillColor" size="small"></el-color-picker>
                        <label class="form-label">色</label>
                    </div>
                </div>
                <div class="l-col">
                    <div class="form-group is-inline">
                        <el-color-picker v-model="params.bgColor" size="small"></el-color-picker>
                        <label class="form-label">背景色</label>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">境界線</label>
                <div class="form-group is-inline">
                    <el-color-picker v-model="params.strokeColor" size="small"></el-color-picker>
                    <label class="form-label">サイズ</label>
                    <el-input-number v-model="params.strokeWidth" size="mini" :min="0"></el-input-number>
                </div>
            </div>

            <div id="footer-bottom">
                <div>
                    <el-button type="primary" icon="el-icon-tickets" @click="onSvgSave('copy')">データをコピー</el-button>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-download" @click="onSvgSave('file')">SVGダウンロード</el-button>
                </div>
                <!--<el-button type="primary" icon="el-icon-download" v-on:click="pngSave">PNGダウンロード</el-button>-->
            </div>
        </div><!-- /.sidebar-in -->
    </aside>
</template>

<script>
export default {
    data() {
        return {
            thisSelectType: ''
        }
    },
    props: {
        selectType: String,
        params: Object
    },
    mounted () {
        this.thisSelectType = this.selectType;
    },
    computed: {
        centerPoint () {
            return this.params.margin / 2
        },
        rotateString () {
            return 'rotate(' + this.params.rotate + ')'
        }
    },
    methods: {
        onSvgSave(saveType) {

            const fileName = 'pattern.svg';

            let content = document.querySelector('#pattern-box').outerHTML;

            // const dataUrl = 'data:image/svg+xml,\n' + encodeURIComponent(content);
            // const dataUrl = encodeURIComponent(content);

            // data-v-の部分を削除
            content = content.replace(/\sdata-v-\w*=""/g, '');

            if (saveType === 'copy') {
                const dataUrl = 'data:image/svg+xml,' + encodeURIComponent(content);

                if(this.textToClipboard(dataUrl)) {
                    this.$message({
                        showClose: true,
                        message: 'クリップボードにコピーしました。',
                        type: 'success'
                    });
                }
            } else {
                const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
                const blob = new Blob([bom, content], {type: 'text/plain'});

                const a = document.createElement('a');
                a.download = fileName;
                a.href = window.URL.createObjectURL(blob);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        },
        // テキストをクリップボードにコピー
        textToClipboard(text){
            // テキストエリア作成
            let copyFrom = document.createElement("textarea");
            copyFrom.textContent = text;

            // Bodyに配置
            let bodyElm = document.getElementsByTagName("body")[0];
            bodyElm.appendChild(copyFrom);

            // テキストエリアの値を選択
            copyFrom.select();
            let retVal = document.execCommand('copy');

            bodyElm.removeChild(copyFrom);
            return retVal;
        }
    },
    watch: {
        thisSelectType: function (inputType) {
            this.$emit('onTypeChange', inputType);
        }
    },
}
</script>


<style scoped lang="scss">
  #sidebar {
    font-size: .8rem;
    position: fixed;
    height: 100%;
    width: 320px;
    background: #F7F7F7;
    top: 0;
    right: 0;
    padding: 15px;
    border-left: 1px solid #DCDFE6;
    /*box-shadow: 0 0 50px rgba(0,0,0,.1);*/
  }
  .form-group {
    margin-bottom: 15px;

    &.mb0 {
        margin-bottom: 0;
    }

    &.is-inline {
      display: flex;
      align-items: center;
    }
  }
  .form-group .form-label {
    margin-right: 10px;
  }

  .input-txt {
    width: 40px;
    margin-left: 10px;
  }
  .input-range {
    width: 100%;
  }
  .form-label {
    font-size: .8rem;
  }

  .l-row {
    display: flex;

    .l-col {
      width: 100%;
    }
  }

  .sidebar-in {
    position: relative;
    height: 100%;
  }

  #footer-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;

    .el-button {
      width: 100%;
        margin-top: 7px;
    }
  }

</style>
